import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { EdpEMenuAppComponent } from "./edp-e-menu-app.component";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { ExternalLinkModule } from "@edp-directives/external-link/external-link.module";



@NgModule({
  declarations: [EdpEMenuAppComponent],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    ExternalLinkModule
  ],
  exports: [EdpEMenuAppComponent]
})
export class EdpEMenuAppModule { }
